import React, { FunctionComponent } from "react";
import { translation } from "@lang/translation";
import { PageErrorTemplate } from "@components/PageErrorTemplate";

export const NotFound: FunctionComponent = () => <PageErrorTemplate error={404} errorMessage={translation.errors.notFound} />;
